<template>
    <div class="contact-page">
        <h1 class="page-title">Contact us</h1>
        <p class="support-description">
            Use the chat bubble <img src="/assets/app/signup/icon-chat-bubble.svg"/> below to be connected to our support team.<br>
            We do our best to answer all questions within 24 hours.
        </p>
        <p class="trouble-description">Still having trouble? Reach out to us directly at <a href="mailto:support@readtheory.org?subject=Contact%20our%20support">support@readtheory.org</a></p>
    </div>
</template>

<script>
  export default {
    mounted() {
      if ($('.topNavPanel-container').length > 0) {
        $('.topNavPanel-container').hide();
      }
    }
  }
</script>

<style scoped lang="scss">

    @import './variables';

    .contact-page {
      max-width: 900px;
      height: calc(100vh - 300px);
      margin: 0 auto;
      padding-top: 20px;

      .page-title {
        text-align: left;
      }

      .support-description, .trouble-description {
        text-align: left;
        font-size: 20px;
      }

      .support-description {
        margin-top: 10px;
        img {
          width: 24px;
        }
      }

      .trouble-description {
        margin-top: 20px;
      }
    }

</style>
